(() => {
  if (window.smilunoraGifVideos) return;
  window.smilunoraGifVideos = true;
  const root = document.body;
  const seen = new WeakSet();
  const visible = new WeakSet();
  const play = video => {
    if (document.hidden || !video.getClientRects().length) return;
    video.muted = true;
    const result = video.play();
    if (result && result.catch) result.catch(() => {});
  };
  const configure = video => {
    video.controls = false;
    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    video.disablePictureInPicture = true;
    video.removeAttribute('controls');
    for (const key of ['muted', 'autoplay', 'loop', 'playsinline']) {
      if (!video.hasAttribute(key)) video.setAttribute(key, '');
    }
    video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
    const wrapper = video.closest('internal-video');
    if (wrapper) {
      if (wrapper.dataset.autoplay !== 'true') wrapper.dataset.autoplay = 'true';
      wrapper.dataset.noPlayBtn = 'true';
      wrapper.classList.add('internal-video--muted');
    }
    if (seen.has(video)) return;
    seen.add(video);
    video.dataset.smilunoraGif = 'true';
    video.addEventListener('loadeddata', () => { if (visible.has(video)) play(video); });
    video.addEventListener('pause', () => {
      if (visible.has(video) && !document.hidden) requestAnimationFrame(() => play(video));
    });
    observer.observe(video);
  };
  const hydrate = video => {
    let changed = false;
    [video, ...video.querySelectorAll('source')].forEach(node => {
      const source = node.getAttribute('data-oral-src') || node.getAttribute('data-src');
      if (!node.getAttribute('src') && source) {
        node.setAttribute('src', source);
        changed = true;
      }
    });
    if (changed) video.load();
  };
  const configureFrame = frame => {
    const source = frame.getAttribute('src');
    if (!source) return;
    let url;
    try { url = new URL(source, location.href); } catch (_) { return; }
    const youtube = /(^|\.)youtube(-nocookie)?\.com$/.test(url.hostname);
    const vimeo = url.hostname === 'player.vimeo.com';
    if (!youtube && !vimeo) return;
    url.searchParams.set('autoplay', '1');
    url.searchParams.set('loop', '1');
    url.searchParams.set('controls', '0');
    url.searchParams.set('playsinline', '1');
    url.searchParams.set(youtube ? 'mute' : 'muted', '1');
    if (youtube) url.searchParams.set('playlist', url.pathname.split('/').pop());
    if (vimeo) url.searchParams.set('background', '1');
    const value = url.toString();
    if (value !== frame.src) frame.src = value;
    const allow = frame.getAttribute('allow') || '';
    if (!allow.includes('autoplay')) frame.setAttribute('allow', allow + '; autoplay');
  };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({target, isIntersecting}) => {
      if (target.tagName === 'VIDEO') {
        if (isIntersecting) {
          visible.add(target);
          hydrate(target);
          play(target);
        } else {
          visible.delete(target);
          target.pause();
        }
      } else if (isIntersecting) {
        const template = target.querySelector('template');
        if (template && template.content.querySelector('video, iframe')) {
          const media = template.content.cloneNode(true);
          media.querySelectorAll('video').forEach(configure);
          media.querySelectorAll('iframe').forEach(configureFrame);
          target.appendChild(media);
          target.setAttribute('loaded', '');
          target.querySelector('.deferred-media__poster')?.setAttribute('hidden', '');
          observer.unobserve(target);
          scan(target);
        }
      }
    });
  }, {threshold: 0.05});
  function scan(container) {
    if (container.matches?.('video')) configure(container);
    if (container.matches?.('iframe')) configureFrame(container);
    container.querySelectorAll?.('video').forEach(configure);
    container.querySelectorAll?.('iframe').forEach(configureFrame);
    const deferred = [...(container.matches?.('deferred-media') ? [container] : []),
      ...container.querySelectorAll?.('deferred-media:not([loaded])') || []];
    deferred.forEach(node => {
      if (node.querySelector('template')?.content.querySelector('video, iframe')) observer.observe(node);
    });
  }
  scan(root);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'attributes' && record.target.tagName === 'VIDEO') {
        if (record.target.controls || !record.target.loop || !record.target.autoplay || !record.target.muted) configure(record.target);
      } else record.addedNodes.forEach(node => { if (node.nodeType === 1) scan(node); });
    });
  }).observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['controls', 'autoplay', 'loop', 'muted']});
  document.addEventListener('visibilitychange', () => {
    root.querySelectorAll('video').forEach(video => {
      if (document.hidden) video.pause();
      else if (visible.has(video)) play(video);
    });
  });
})();